import baseV3Service from './base/baseV3Service.js';

const createAiDiscoverability = (payload, config) => {
    return baseV3Service.post("ai-discoverability", payload, config);
};
const createAiDiscoverabilityAssessment = (payload, config) => {
    return baseV3Service.post("ai-discoverability/assessments", payload, config);
};
const getAiDiscoverability = (id, config) => {
    return baseV3Service.get(`ai-discoverability/${id}`, config);
};

export { createAiDiscoverability, createAiDiscoverabilityAssessment, getAiDiscoverability };
